<template>
  <div>
    <!-- {{ options_url }} -->
    <div :class="inClass">
      <!-- 默认输入框 -->
      <el-input v-model="localValue" :disabled="disabled" placeholder="请输入" v-if="type == 'str' || type == 'number' || type == 'textarea'" :type="type"></el-input>
      <!-- 开关 -->
      <el-switch v-model="localValue" v-else-if="type == 'switch'"></el-switch>
      <!-- 下拉选择 -->
      <el-select v-model="localValue" placeholder="请选择" v-else-if="type == 'select'" filterable>
        <el-option v-for="(item, index) in locaOptions" :key="index" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <!-- 日期选择 -->
      <el-date-picker v-model="localValue" v-else-if="type == 'date'" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期时间"> </el-date-picker>
      <!-- 单个时间选择 -->
      <el-date-picker v-model="localValue" v-else-if="type == 'datetime'" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间"> </el-date-picker>
      <!-- 日期时间范围选择 -->
      <el-date-picker
        v-else-if="type == 'datetimerange'"
        v-model="localValue"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        format="yyyy-MM-dd HH:mm:ss"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <!-- 单选 -->
      <div v-else-if="type == 'radio'">
        <el-radio v-model="localValue" :label="item" v-for="(item, index) in options" :key="index">
          {{ item }}
        </el-radio>
      </div>
      <!-- 单选-按钮 -->
      <div v-else-if="type == 'radio-btn'">
        <el-radio-button v-model="localValue" :label="item" v-for="(item, index) in options" :key="index">
          {{ item }}
        </el-radio-button>
      </div>
      <div v-else-if="type == 'btn'">
        <el-button type="primary">按钮</el-button>
      </div>

      <div v-else-if="type == 'btns'" class="ac">
        <div v-for="(i, x) in options" :key="x">
          <el-button :type="i.type" size="mini" @click="btn_func(i.event)" :class="i.class">{{ i.name }}</el-button>
        </div>
      </div>

      <div v-if="remarks && remarks != ''" style="color: #909399" class="fs12">
        {{ remarks }}
      </div>
    </div>
  </div>
</template>
<script>
  import {http_get} from '@/api/api'
  import _ from 'lodash'
  export default {
    props: {
      value: {
        // 接收任意类型
        type: null, // 显式声明接受任意类型
        required: true
      },
      type: {
        type: String,
        default: 'str'
      },
      options: {
        type: Array,
        default: () => [] // 使用工厂函数返回新数组
      },
      inClass: {
        type: String,
        default: ''
      },
      config: {
        type: Object,
        default: null
      },
      remarks: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      options_url: {
        type: null,
        default: null
      }
    },
    data() {
      return {
        localValue: _.cloneDeep(this.value), // 深拷贝初始化
        locaOptions: this.options
      }
    },
    watch: {
      value: {
        handler(newVal) {
          if (!this.isEqual(newVal, this.localValue)) {
            this.localValue = _.cloneDeep(newVal) // 父级更新时同步
          }
        },
        deep: true // 深度监听对象/数组变化
      },

      localValue: {
        handler(newVal) {
          if (!this.isEqual(newVal, this.value)) {
            this.$emit('input', _.cloneDeep(newVal)) // 值变化时通知父级
            this.change_value()
          }
        },
        deep: true
      }
    },
    async created() {
      if (this.options_url) {
        const res = await http_get(this.options_url)
        if (res.code == 200) {
          this.locaOptions = res.data
        }
      }

      if (this.type == 'select' && this.options && !this.localValue) {
        this.localValue = this.options[0].value
      }
      if (this.type == 'datetime' && !this.localValue) {
        this.localValue = this.currentDatetime
      }
    },
    computed: {
      currentDatetime() {
        const now = new Date()
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const day = String(now.getDate()).padStart(2, '0')
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const seconds = String(now.getSeconds()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      }
    },
    methods: {
      btn_func(e) {
        this.$emit('event', e)
      },
      change_value() {
        this.$emit('change', true)
      },
      isEqual(a, b) {
        // 智能值比对（处理所有数据类型）
        if (typeof a !== typeof b) return false
        if (typeof a === 'object' && a !== null && b !== null) {
          // 处理引用类型
          return _.isEqual(a, b) // 使用 lodash 深度比对
        }
        return a === b // 基本类型直接比对
      },
      handleInput(rawValue) {
        // 输入处理（类型转换）
        let processed = rawValue
        if (typeof this.value === 'number') {
          // 自动类型转换（根据初始值类型）
          processed = parseFloat(rawValue) || 0
        } else if (typeof this.value === 'boolean') {
          processed = Boolean(rawValue)
        }

        this.localValue = processed
      }
    }
  }
</script>

<style lang="scss" scoped></style>
